var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopyLightGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5499 4.15002H8.7499V5.35002H9.5499C9.8999 5.35002 10.1499 5.60002 10.1499 5.95002V9.55002C10.1499 9.90002 9.8999 10.15 9.5499 10.15H5.9499C5.5999 10.15 5.3499 9.90002 5.3499 9.55002V8.85002H4.1499V9.55002C4.1499 10.55 4.9499 11.35 5.9499 11.35H9.5499C10.5499 11.35 11.3499 10.55 11.3499 9.55002V5.95002C11.3499 4.95002 10.5499 4.15002 9.5499 4.15002",
    fill: "#C2C4C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4499 1.85002C2.0999 1.85002 1.8499 2.10002 1.8499 2.45002V6.05002C1.8499 6.40002 2.0999 6.65002 2.4499 6.65002H6.0499C6.3999 6.65002 6.6499 6.40002 6.6499 6.05002V2.45002C6.6499 2.10002 6.3999 1.85002 6.0499 1.85002H2.4499ZM6.0499 7.85002H2.4499C1.4499 7.85002 0.649902 7.05002 0.649902 6.05002V2.45002C0.649902 1.45002 1.4499 0.650024 2.4499 0.650024H6.0499C7.0499 0.650024 7.8499 1.45002 7.8499 2.45002V6.05002C7.8499 7.05002 7.0499 7.85002 6.0499 7.85002V7.85002Z",
    fill: "#C2C4C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyLightGray);
export default __webpack_public_path__ + "static/media/icon_copy_light_gray.61b8b0a29f214566edce107002b2615d.svg";
export { ForwardRef as ReactComponent };